import { BaseModel } from "../base-model";

export interface IUserInfoModel {
  Id?: number;
  GroupID?: number;
  DepartmentId?: number;
  SiteId?: number;
  Name?: string;
  ShortName?: string;
  Email?: string;
  Photo?: string;
  DirectPhone?: string;
  MobilePhone?: string;
}
export class UserInfoModel extends BaseModel<IUserInfoModel>
  implements IUserInfoModel {
  Id?: number;
  GroupID?: number;
  DepartmentId?: number;
  SiteId?: number;
  Name?: string;
  ShortName?: string;
  Email?: string;
  Photo?: string;
  DirectPhone?: string;
  MobilePhone?: string;
  /**
   *
   */
  constructor(options?: IUserInfoModel) {
    super(options);
  }
}
